// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { DownloadTifThunk, DownloadPanoramaThunk, DownloadPoleTagImageThunk } from 'Features/project/projectThunk';

// tif/las presigned downloads go by BASENAME through the shared endpoint;
// pano and pole-image zips download by document ID through their own routes.
export const downloadFileThunk = (file: IDownloadableFileRef) => {
  if (file.kind === 'pano') return DownloadPanoramaThunk(file.id);
  if (file.kind === 'poleImage') return DownloadPoleTagImageThunk(file.id);
  return DownloadTifThunk(file.name);
};

export default downloadFileThunk;
